module.exports = __webpack_public_path__ + "img/678CBADB.2d0830d1.png";